import React from "react";
import { inject, observer } from "mobx-react";
import CustomerSelector from './customerselector'

@inject("store")
@observer
export default class SiteSettingsPortal extends React.Component {
    //targetElement = null;
    constructor(props) {
        super(props);

        // Server?
        const serverRender = typeof window === 'undefined';

    }




    render() {
        const navigation = this.props.store.navigation;

        const serverRender = typeof window === 'undefined';

        if (!serverRender) {
            document.title = this.props.store.navigation.pageContent.Title;
        }

        const pageContentClasses = [
            "page-content",
            this.props.store.navigation.TemplateAlias
        ];

        // Handle serverLocation or client location
        

        
        if (this.props.store.account.showSettings()) {
            return (<CustomerSelector />);
        } else {
            return (
                this.props.children
            );
        }
    }
}





